import { Component, OnInit, Input, EventEmitter, Output, ViewChild, SimpleChanges } from '@angular/core';
import { egretAnimations } from "../../../shared/animations/egret-animations";
import { CheckButtonEvent, ColumnDefinition, ExtraButtonEvent, ExtraButtons } from 'app/models';
import { MatPaginator } from '@angular/material/paginator';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Paginator } from 'app/models/shared/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { ChipStyleStatusEnum, StatusElementaPorukeEnum, StatusSvojstvaEnum } from 'app/models/shared/enums';
import { AkcijeNadEntitetom } from 'app/shared/enums/akcije-nad-entitetom.enum';
import { JwtAuthService } from 'app/auth/services/jwt-auth.service';
import { TranslateService } from '@ngx-translate/core';
import { AkcijeNadSvojstvom } from 'app/shared/enums/akcije-nad-svojstvom.enum';
@Component({
  selector: 'app-crud-ngx-table',
  templateUrl: './crud-ngx-table.component.html',
  styles: ['table {width: 100%; }'],
  styleUrls: ['./crud-ngx-table.component.scss'],
  animations: egretAnimations
})
export class CrudNgxTableComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // inputs
  @Input() showHorizontalScroll = false;
  @Input() showLoader = false;
  @Input() items: [] = [];
  @Input() columnDefinition: ColumnDefinition[] = [];
  @Input() addBtnName: string = null;
  @Input() deleteButton: boolean = false;
  @Input() translatePrefix: string = "";
  @Input() totalElements: number = 0;
  @Input() viewButton: boolean = false;
  @Input() editButton: boolean = false;
  @Input() inputFooter: boolean = false;
  @Input() selectionFields: Map<string, any[]> = new Map();
  @Input() numPage: number = 1;
  @Input() jeMatura: boolean;
  @Input() extraButtons: ExtraButtons[] = [];
  @Input() showPaginator: boolean = true;
  @Input() pageSize: number = 10;
  @Input() fiksnaSirinaKolona: boolean = false;
  @Input() dugmiciSaDesneStrane: boolean = false;
  @Input() dugmeDodaj: boolean = false;
  @Input() vecIzabraniEntiteti: string[] = [];
  @Input() cb: boolean = false;
  @Input() showNumberColumn: boolean = false;
  @Input() showNumberColumnHeader: boolean = true;
  @Input() proveriUloge: boolean = false;
  @Input() callbackFunkcijaProveriUloguZaExtraBtn: (row: any, akcija: AkcijeNadEntitetom) => boolean;
  @Input() isDialog: boolean = false;

  //outputs
  @Output() openPopup = new EventEmitter();
  @Output() downloadDocument = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() view = new EventEmitter();
  @Output() add = new EventEmitter();
  @Output() dugmeDodajClicked = new EventEmitter();
  @Output() pageChanged = new EventEmitter<Paginator>();
  @Output() sortChanged = new EventEmitter<Sort>();

  @Output() extraBtn = new EventEmitter<ExtraButtonEvent>();
  @Output() checkBtn = new EventEmitter<CheckButtonEvent>();
  dataRows: any = [];
  columnNames: string[] = [];
  addForm: UntypedFormGroup;
  chipStyleStatusEnum = ChipStyleStatusEnum;
  statusSvojstvaEnum = StatusSvojstvaEnum;
  statusElementaPorukeEnum = StatusElementaPorukeEnum;

  constructor(private fb: UntypedFormBuilder, private jwtService: JwtAuthService, private translate: TranslateService) {
    this.addForm = this.fb.group({});
  }

  ngOnInit() {
    this.columnNames = [];
    if (this.cb) {
      this.columnNames.push("cb");
    }

    if (!this.dugmiciSaDesneStrane) {
      this.columnNames.push("actions");
    }

    if (this.showNumberColumn) {
      this.columnNames.push("numberColumn");
    }

    this.columnNames = [...this.columnNames, ...this.columnDefinition.map(x => x.columnName)];
    if (this.dugmiciSaDesneStrane) {
      this.columnNames.push("actionsDesno")
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cb?.currentValue) {
      this.columnNames.unshift("cb");
    }

    if (changes.columnDefinition?.currentValue) {
      this.columnNames = [];
      if (this.cb) {
        this.columnNames.push("cb");
      }

      if (!this.dugmiciSaDesneStrane) {
        this.columnNames.push("actions");
      }

      if (this.showNumberColumn) {
        this.columnNames.push("numberColumn");
      }

      this.columnNames = [...this.columnNames, ...changes.columnDefinition?.currentValue.map(x => x.columnName)];
      if (this.dugmiciSaDesneStrane) {
        this.columnNames.push("actionsDesno")
      }
    }
  }

  setPage(data) {
    this.pageChanged.emit({ pageNumber: data['pageIndex'] + 1, pageSize: data['pageSize'] });
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
    });

    this.sort.sortChange
      .pipe(
        tap(() => this.sortChanged.emit({ active: this.sort.active, direction: this.sort.direction }))
      )
      .subscribe();

  }

  openPopUp(data: any = {}) {
    this.openPopup.emit(data);
  }

  download(data: any = {}) {
    this.downloadDocument.emit(data);
  }

  deleteItem(row) {
    this.delete.emit(row);
  }

  viewItem(row) {
    this.view.emit(row);
  }

  //This shouldn't be part of table component since it is reusable component, but it was too late. 
  selectionChanged(event) {
    if (event.value === 'Online') {
      this.addForm.controls['extSystemId'].enable();
    }
    else {
      this.addForm.controls['extSystemId'].patchValue('');
      this.addForm.controls['extSystemId'].disable();
    }
  }

  addItem() {
    this.add.emit(this.addForm.value);
    if (this.inputFooter) {
      this.columnDefinition.forEach(column => {
        this.addForm.controls[column.columnName].patchValue('');
        this.addForm.controls[column.columnName].markAsUntouched();
      })
    }
    this.addForm.reset();
  }

  switchToFirstPage() {
    this.paginator.firstPage();
  }

  subString(text: string, _od: number, _do: number) {
    if (text.length > 1) {
      return text[0].substring(_od, _do) + "...";
    }
  }

  formatToolTip(text: string) {
    const charLimit = 27;
    let output = '';
    for (let i = 0; i < text.length; i++) {
      output += text[i];
      if ((i + 1) % charLimit === 0 && i !== 0 && i !== text.length - 1) {
        output += ' ';
      }
    }
    return output;
  }

  extraBtnClick(row, btnAction) {
    this.extraBtn.emit({
      data: row,
      btnAction: btnAction
    });
    if (this.daLiJeAkcijaHighlight(btnAction))
      this.highlightSelectedRow(row);
  }

  private daLiJeAkcijaHighlight(btnAction: any) {
    return btnAction === AkcijeNadSvojstvom.POMERANJE_GORE ||
      btnAction === AkcijeNadSvojstvom.POMERANJE_DOLE;
  }

  highlightedRowId: number | null = null;
  private highlightTimeout: any;
  private highlightSelectedRow(row): void {
    if (this.highlightTimeout) {
      clearTimeout(this.highlightTimeout);
    }

    // Kratko skloni highlight da bi se CSS animacija ponovo pokrenula
    this.highlightedRowId = null;

    setTimeout(() => {
      this.highlightedRowId = row.id;
    }, 10); // dovoljno 10-20ms

    this.highlightTimeout = setTimeout(() => {
      this.highlightedRowId = null;
      this.highlightTimeout = null;
    }, 3000);
  }

  hasRole(btnAction: AkcijeNadEntitetom, row: any): boolean {
    if (!this.proveriUloge) return true;

    return this.callbackFunkcijaProveriUloguZaExtraBtn(row, btnAction);
  }

  dodajClicked(event, row) {
    if (event.style.backgroundColor != 'grey') {
      event.textContent = this.translate.instant(this.translatePrefix + 'dodato');
      event.style.backgroundColor = 'grey';
      this.dugmeDodajClicked.emit({
        data: row,
        dodato: true
      })
    } else {
      event.textContent = this.translate.instant(this.translatePrefix + 'dodaj');
      event.style.backgroundColor = '#10174C';
      this.dugmeDodajClicked.emit({
        data: row,
        dodato: false
      })
    }
  }

  checkBtnClick(event, row) {
    this.checkBtn.emit({
      data: row.sifra,
      checked: event
    });
  }

  parseJsonColumn(row: any, column: any): any {
    try {
      const parsedJsonArray = JSON.parse(row.dodatneKolone); // Parse the string into an array of objects

      const matchingItem = parsedJsonArray.find(item => item.elementSifra == column.idColumnName);

      return matchingItem ? matchingItem['vrednostPovezaneStavke'] != null ? matchingItem['vrednostPovezaneStavke']
        : matchingItem['vrednost'] != '' ? matchingItem['vrednost'] : null : null;
    } catch (e) {
      return null;
    }
  }

  getColorByLevel(nivo: number): string {
    const baseHue = 207; // plava boja u HSL
    const maxLevel = 15; // maksimalni nivo u hijerarhiji
    const minLightness = 25; // tamna boja za najniži nivo
    const maxLightness = 150; // svetlija boja za najviši nivo

    // skaliranje svetline u odnosu na nivo
    const lightness = minLightness + ((nivo - 1) / (maxLevel - 1)) * (maxLightness - minLightness);
    return `hsl(${baseHue}, 70%, ${lightness}%)`;
  }

}